import Dropdown from '../../md-dropdown/index';
import { zeroPad } from '../common/util';
import type { ITimezoneDropdownOption } from '../../interface/ITimezone';
import type { DateTime } from 'luxon';

class TimezoneDropdown {
  $parent!: HTMLElement;

  #dropdown!: Dropdown;

  constructor(option: ITimezoneDropdownOption) {
    this.initDropdown(option);
  }

  initDropdown({ element, name, data, changeCallback }: ITimezoneDropdownOption) {
    this.$parent = element?.querySelector('.timezone-dropdown')!;

    this.#dropdown = new Dropdown({
      parent: this.$parent,
      name,
      data,
      btnType: 'no-border',
      changeCallback
    });

    this.$parent?.querySelector('.dropdown-btn')?.classList?.add('timezone-current');
  }

  updateDropdown(time: DateTime) {
    const { hour } = time || {};
    const value = `${zeroPad(hour)}:00`;
    const activeValue = this.#dropdown?.activeData?.[0]?.value;

    if(value !== activeValue) {
      this.#dropdown?.activeValue([value]);
    }
  }
}

export default TimezoneDropdown;
